import React from 'react';
import { Link } from 'react-router-dom';

import './Footer.css';

const Footer = () => {
  return (
    <div className="container-fluid footer paralax">
      <div className="row overlay">
        <div className="col-12">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-4 mb-5">
                <div className="row">
                  <div className="col-12 natek-logo">
                    <img src="./images/natek_logo2.png" alt="Natek Logo" />
                  </div>
                  <div className="col-6 coop">
                    <p>Member of:</p>
                    <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', padding: '5px', marginBottom: '5px' }}>
                      <img src="https://natek.eu/wp-content/themes/natek/assets/images/cci_france_pologne.png" alt="pologne-logo" />
                    </div>
                    <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', padding: '5px', marginBottom: '5px' }}>
                      <img src="https://natek.eu/wp-content/themes/natek/assets/images/logo_krivky.png" alt="logo-krivky" />
                    </div>
                    <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', padding: '5px', marginBottom: '5px' }}>
                      <img src="https://natek.eu/wp-content/themes/natek/assets/images/swisscp.png" alt="logo-swiss" />
                    </div>
                  </div>
                  <div className="col-6 coop">
                    <p>Certified by:</p>
                    <div style={{ backgroundColor: 'rgba(255, 255, 255, 0)', marginBottom: '5px' }}>
                      <img src="https://natek.eu/wp-content/themes/natek/assets/images/footer_certified.png" alt="logo-certif" />
                    </div>
                  </div>
                </div>
                <div className="row"></div>
              </div>
              <div className="col-12 col-md-8">
                <div className="row">
                  <div className="col-12 col-md-4">
                    <p className="footer-heading">Info</p>
                    <ul className="mb-5">
                      <li>
                        <Link to="/">IT Solutions</Link>
                      </li>
                      <li>
                        <Link to="/">Careers</Link>
                      </li>
                      <li>
                        <Link to="/">About us</Link>
                      </li>
                      <li>
                        <Link to="/">Latest news</Link>
                      </li>
                      <li>
                        <Link to="/">Contact</Link>
                      </li>
                      <li>
                        <Link to="/profile">My profile</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-12 col-md-4">
                    <p className="footer-heading">Services</p>
                    <ul className="mb-5">
                      <li>
                        <Link to="/">Cloud</Link>
                      </li>
                      <li>
                        <Link to="/">Network services</Link>
                      </li>
                      <li>
                        <Link to="/">SAP</Link>
                      </li>
                      <li>
                        <Link to="/">Customer support</Link>
                      </li>
                      <li>
                        <Link to="/">Software Development</Link>
                      </li>
                      <li>
                        <Link to="/">Quality Assurance</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-12 col-md-4">
                    <p className="footer-heading">Links</p>
                    <ul>
                      <li>
                        <span className="socials">
                          <Link to="/">
                            <i className="bi bi-facebook"></i>
                          </Link>
                          <Link to="/">
                            <i className="bi bi-instagram"></i>
                          </Link>
                          <Link to="/">
                            <i className="bi bi-youtube"></i>
                          </Link>
                          <Link to="/">
                            <i className="bi bi-twitter"></i>
                          </Link>
                          <Link to="/">
                            <i className="bi bi-linkedin"></i>
                          </Link>
                        </span>
                      </li>
                      <li>
                        <Link to="/">Privacy policy</Link>
                      </li>
                      <li>
                        <Link to="/">Environmental policy</Link>
                      </li>
                      <li>
                        <Link to="/">Quality policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
